import { render, staticRenderFns } from "./ManageFlag.vue?vue&type=template&id=92e4ce1e&"
import script from "./ManageFlag.vue?vue&type=script&lang=js&"
export * from "./ManageFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports